class WeddingConfigurator extends HTMLElement {
  constructor() {
    super();
    this.formId = this.dataset.productFormId;
    this.charactersContainer = this.querySelector('[data-wedding-characters-container]');
    this.namesContainer = this.querySelector('[data-wedding-names-container]');
    this.characterTemplate = this.querySelector('[data-wedding-character-template]');
    this.countSelect = this.querySelector('[data-wedding-character-count]');
    this.animalsContainer = this.querySelector('[data-wedding-animals-container]');

    this.productRoot = this.closest('.product') || document;

    if (this.countSelect) {
      this.countSelect.addEventListener('change', this.onCountChange.bind(this));
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
    }

    this.renderCharacters(0);
    this.updateNamesVisibility();
    this.updateAnimalTypeFields(this.currentAnimalettiCount());
    this.relocateCharacterCountField();
    this.addOptionHints();
  }

  addOptionHints() {
    const hints = {
      'Animaletti extra': '(+3€/cad)',
      'Nomi sopra le teste': '(+5€)',
      'Cornice': '(legno +5€)',
    };
    Object.entries(hints).forEach(([optionName, hintText]) => {
      const input = this.productRoot.querySelector(`input[data-option-name="${optionName}"]`);
      const fieldset = input ? input.closest('fieldset') : null;
      const legend = fieldset ? fieldset.querySelector('legend') : null;
      if (!legend || legend.querySelector('.wedding-configurator__hint')) return;
      const span = document.createElement('span');
      span.className = 'wedding-configurator__hint';
      span.textContent = ' ' + hintText;
      legend.appendChild(span);
    });
  }

  relocateCharacterCountField() {
    if (!this.countSelect) return;
    const row = this.countSelect.closest('.wedding-configurator__select-row');
    if (!row) return;
    row.classList.add('wedding-configurator__select-row--in-picker');
    const animalettiInput = this.productRoot.querySelector('input[data-option-name="Animaletti extra"]');
    const animalettiFieldset = animalettiInput ? animalettiInput.closest('fieldset') : null;
    if (animalettiFieldset && animalettiFieldset.parentNode && row.nextElementSibling !== animalettiFieldset) {
      animalettiFieldset.parentNode.insertBefore(row, animalettiFieldset);
    }
  }

  getNamesOptionInputs() {
    return this.productRoot.querySelectorAll('input[data-option-name="Nomi sopra le teste"]');
  }

  getAnimalettiInputs() {
    return this.productRoot.querySelectorAll('input[data-option-name="Animaletti extra"]');
  }

  onVariantChange() {
    this.updateNamesVisibility();
    this.updateAnimalettiConstraint(this.currentCharacterCount());
    this.updateAnimalTypeFields(this.currentAnimalettiCount());
    this.relocateCharacterCountField();
    this.addOptionHints();
  }

  currentCharacterCount() {
    return this.countSelect ? parseInt(this.countSelect.value, 10) || 0 : 0;
  }

  currentAnimalettiCount() {
    const checked = Array.from(this.getAnimalettiInputs()).find((input) => input.checked);
    return checked ? parseInt(checked.value, 10) || 0 : 0;
  }

  onCountChange(event) {
    const count = parseInt(event.target.value, 10) || 0;
    this.renderCharacters(count);
    this.updateAnimalettiConstraint(count);
    this.updateNamesVisibility();
  }

  renderCharacters(count) {
    if (!this.charactersContainer || !this.characterTemplate) return;

    this.charactersContainer.innerHTML = '';

    for (let i = 1; i <= count; i++) {
      this.charactersContainer.appendChild(this.buildCharacterFieldset(i));
    }

    this.updateNamesVisibility();
  }

  buildCharacterFieldset(index) {
    const html = this.characterTemplate.innerHTML
      .replaceAll('__INDEX__', index)
      .replaceAll('__FORM_ID__', this.formId);
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html.trim();
    const fieldset = wrapper.firstElementChild;

    const fieldNames = {
      sesso: `properties[Personaggio ${index} - Sesso]`,
      nome: `properties[Nome personaggio ${index}]`,
      eta: `properties[Personaggio ${index} - Età]`,
      stoffa_colore: `properties[Personaggio ${index} - Colore stoffa]`,
      stoffa_numero: `properties[Personaggio ${index} - Fantasia stoffa]`,
      pantaloni_o_jeans: `properties[Personaggio ${index} - Pantaloni o jeans]`,
      colore_pantaloni: `properties[Personaggio ${index} - Colore pantaloni]`,
      colore_jeans: `properties[Personaggio ${index} - Colore jeans]`,
      papillon_tipo: `properties[Personaggio ${index} - Tipo papillon]`,
      papillon_preferenze: `properties[Personaggio ${index} - Preferenze papillon]`,
    };

    fieldset.querySelectorAll('[data-field]').forEach((el) => {
      const key = el.dataset.field;
      if (fieldNames[key]) {
        el.setAttribute('name', fieldNames[key]);
      }
      el.setAttribute('form', this.formId);
    });

    const sessoSelect = fieldset.querySelector('[data-field="sesso"]');
    const femminaFields = fieldset.querySelector('[data-wedding-femmina-fields]');
    const maschioFields = fieldset.querySelector('[data-wedding-maschio-fields]');
    const pantaloniToggle = fieldset.querySelector('[data-wedding-pantaloni-toggle]');
    const pantaloniColorRow = fieldset.querySelector('[data-wedding-pantaloni-color]');
    const jeansColorRow = fieldset.querySelector('[data-wedding-jeans-color]');
    const papillonFields = fieldset.querySelector('[data-wedding-papillon-fields]');

    const setGroupDisabled = (group, disabled) => {
      if (!group) return;
      group.hidden = disabled;
      group.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = disabled;
      });
    };

    const applySesso = () => {
      const isMaschio = sessoSelect.value === 'Maschio';
      setGroupDisabled(femminaFields, isMaschio);
      setGroupDisabled(maschioFields, !isMaschio);
      if (!isMaschio) return;
      applyPantaloniToggle();
    };

    const applyPantaloniToggle = () => {
      if (!pantaloniToggle) return;
      const isPantaloni = pantaloniToggle.value === 'Pantaloni';
      const isJeans = pantaloniToggle.value === 'Jeans';
      setGroupDisabled(pantaloniColorRow, !isPantaloni);
      setGroupDisabled(jeansColorRow, !isJeans);
      setGroupDisabled(papillonFields, !(isPantaloni || isJeans));
    };

    if (sessoSelect) sessoSelect.addEventListener('change', applySesso);
    if (pantaloniToggle) pantaloniToggle.addEventListener('change', applyPantaloniToggle);

    applySesso();

    return fieldset;
  }

  updateNamesVisibility() {
    const checked = Array.from(this.getNamesOptionInputs()).find((input) => input.checked);
    const showNames = checked ? checked.value.startsWith('Sì') : false;

    // The bride and groom keep their own box; every other character carries
    // its name inside its own "Personaggio N" fieldset.
    if (this.namesContainer) {
      this.namesContainer.hidden = !showNames;
      this.namesContainer.querySelectorAll('input').forEach((el) => {
        el.disabled = !showNames;
      });
    }

    if (this.charactersContainer) {
      this.charactersContainer.querySelectorAll('[data-wedding-nome-field]').forEach((field) => {
        field.hidden = !showNames;
        field.querySelectorAll('input').forEach((el) => {
          el.disabled = !showNames;
        });
      });
    }
  }

  updateAnimalettiConstraint(additionalCharactersCount) {
    const inputs = this.getAnimalettiInputs();
    if (!inputs.length) return;
    const maxAllowed = additionalCharactersCount >= 3 ? 2 : 3;

    inputs.forEach((input) => {
      const value = parseInt(input.value, 10) || 0;
      const shouldDisable = value > maxAllowed;
      input.disabled = shouldDisable;
      input.classList.toggle('disabled', shouldDisable);

      if (shouldDisable && input.checked) {
        const fallback = Array.from(inputs).find((i) => (parseInt(i.value, 10) || 0) === maxAllowed);
        if (fallback) {
          fallback.checked = true;
          fallback.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  updateAnimalTypeFields(count) {
    if (!this.animalsContainer) return;
    this.animalsContainer.innerHTML = '';
    if (!count) return;

    const buildSelectRow = (labelText, name, options) => {
      const row = document.createElement('div');
      row.className = 'wedding-configurator__select-row';

      const label = document.createElement('label');
      label.className = 'form__label';
      label.textContent = labelText;

      const selectWrap = document.createElement('div');
      selectWrap.className = 'select';

      const select = document.createElement('select');
      select.className = 'select__select';
      select.setAttribute('form', this.formId);
      select.setAttribute('name', name);
      options.forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });

      selectWrap.appendChild(select);
      row.appendChild(label);
      row.appendChild(selectWrap);
      return { row, select };
    };

    if (count === 3) {
      const { row, select } = buildSelectRow(
        'Quanti gatti (su 3 animaletti)',
        'properties[Animaletti - Numero gatti]',
        ['0', '1', '2', '3']
      );

      const summary = document.createElement('p');
      summary.className = 'wedding-configurator__hint';

      const caniInput = document.createElement('input');
      caniInput.type = 'hidden';
      caniInput.setAttribute('form', this.formId);
      caniInput.setAttribute('name', 'properties[Animaletti - Numero cani]');

      const updateSummary = () => {
        const gatti = parseInt(select.value, 10) || 0;
        const cani = 3 - gatti;
        summary.textContent = `→ ${cani} ${cani === 1 ? 'cane' : 'cani'}`;
        caniInput.value = String(cani);
      };
      select.addEventListener('change', updateSummary);
      updateSummary();

      this.animalsContainer.appendChild(row);
      this.animalsContainer.appendChild(summary);
      this.animalsContainer.appendChild(caniInput);
      return;
    }

    for (let i = 1; i <= count; i++) {
      const labelText = count === 1 ? 'Tipo animaletto' : `Animale ${i}`;
      const name = count === 1 ? 'properties[Animaletto - Tipo]' : `properties[Animaletto ${i} - Tipo]`;
      const { row } = buildSelectRow(labelText, name, ['Cane', 'Gatto']);
      this.animalsContainer.appendChild(row);
    }
  }
}

customElements.define('wedding-configurator', WeddingConfigurator);
